import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class Ac2Provider extends HttpRequest {
  getRequestLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/ac2/request-log', query)
  }

  getAccessTokens (query) {
    this.setHeader(getAuthToken())
    return this.get('/ac2/access-token', query)
  }

  generateAccessToken () {
    this.setHeader(getAuthToken())
    return this.post('/ac2/access-token/generate')
  }

  // เช็คสถานะ SO สดจาก WMS (1 request = 1 warehouse, สูงสุด 500 ใบ) อาจนานถึง ~2.5 นาที จึงตั้ง timeout 200s
  getWmsOrderStatuses (payload) {
    this.setHeader(getAuthToken())
    return this.post('/ac2/orders/wms-status', payload, { timeout: 200000 })
  }
}
